/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum AutorizacaoDadosGuiaAliases {
  ACCORDION_ANEXO = 'accordion-anexo',
  ACCORDION_GLOSAS_OCORRENCIA = 'accordion-glosas-ocorrencia',
  ACCORDION_PROCEDIMENTO_MATERIAL = 'accordion-procedimento-material',
  ATTACHMENTS_LIST_ANEXO = 'attachments-list-anexo',
  AVATAR_0 = 'avatar-0',
  DECK_PROCEDIMENTO_MATERIAL = 'deck-procedimento-material',
  FETCH_ANEXO = 'fetch-anexo',
  FETCH_PROCEDIMENTO_MATERIAL = 'fetch-procedimento-material',
  FIELD_DESCRICAO = 'field-descricao',
  FIELD_DS_PROC_MAT = 'field-dsProcMat',
  FIELD_GLOSAS_OCORRENCIAS = 'field-glosas-ocorrencias',
  FIELD_GLOSAS_OCORRENCIAS_ITEM = 'field-glosas-ocorrencias-item',
  FIELD_LIST_GLOSAS_OCORRENCIAS = 'field-list-glosas-ocorrencias',
  FIELD_QT_AUTORIZADA = 'field-qtAutorizada',
  FIELD_QT_SOLICITADA = 'field-qtSolicitada',
  FORM_GLOSAS_OCORRENCIAS = 'form-glosas-ocorrencias',
  FRAGMENT_AUTORIZACAO_GUIA_FORM = 'fragment-autorizacao-guia-form ',
  HPMS_CUSTOM_CARD_CONTENT_COLLAPSE = 'hpms-custom-card-content-collapse',
  HPMS_CUSTOM_CARD_PROCEDIMENTO_MATERIAL = 'hpms-custom-card-procedimento-material',
  HPMS_DYNAMIC_ACTION = 'hpms-dynamic-action',
  HPMS_DYNAMIC_STAMP = 'hpms-dynamic-stamp',
  LAYOUT_AUTORIZACAO_DADOS_GUIA = 'layout-autorizacao-dados-guia',
  MAPPER_0 = 'mapper-0',
  MAPPER_ANEXO = 'mapper-anexo',
  PANEL_ANEXO = 'panel-anexo',
  PANEL_DADO_GUIA = 'panel-dado-guia',
  PANEL_GLOSAS_OCORRENCIAS = 'panel-glosas-ocorrencias',
  PANEL_PROCEDIMENTO_MATERIAL = 'panel-procedimento-material',
  PANEL_WRAPPER_GLOSAS_OCORRENCIAS = 'panel-wrapper-glosas-ocorrencias',
  TEXT_0 = 'text-0',
  TEXT_1 = 'text-1',
  TEXT_2 = 'text-2',
  TEXT_ANEXO_TITILE = 'text-anexo-titile',
  TEXT_DESCRICAO = 'text-descricao',
  TEXT_QT_AUTORIZADA = 'text-qtAutorizada',
  TEXT_QT_SOLICITADA = 'text-qtSolicitada',
  TEXT_TITLE = 'text-title',
}
export { AutorizacaoDadosGuiaAliases };
